import { render, staticRenderFns } from "./FileHandler.vue?vue&type=template&id=3e5ffc3c&"
import script from "./FileHandler.vue?vue&type=script&lang=js&"
export * from "./FileHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports